import type { Region } from '~~/core/entities/Region';

import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';
import { getUrlFromStaticDNS } from '@/utils';
import { PropertyTypeEnum } from '~/core/entities/CRMEnums';
import { getRegionMetadata } from './utils';

const regionName = 'Itaim Bibi';

const metaTags = getRegionMetadata(regionName, 'São Paulo', { gender: 'male' });

const region: Region = {
	name: regionName,
	state: 'SP',
	city: 'São Paulo',
	path: '/bairros/itaim-bibi',
	image: getUrlFromStaticDNS('/images/regions/itaim-bibi/banner.webp'),
	metaTags,
	info: {
		title: '',
		description:
			'São Paulo é uma cidade vibrante e diversificada, conhecida por sua infraestrutura moderna, opções culturais ricas e oportunidades de negócios incomparáveis. Morar em São Paulo significa estar próximo de tudo: excelentes restaurantes, shoppings de alto padrão, parques, centros culturais e muito mais. Bairros como Jardins, Moema e Itaim Bibi oferecem uma qualidade de vida excepcional com suas ruas arborizadas e serviços de alto nível.</br></br>Optar pela Pilar para encontrar seu imóvel ideal em São Paulo garante acesso a uma seleção exclusiva de propriedades de alto padrão. Nossa equipe de corretores qualificados está pronta para oferecer suporte personalizado, desde a busca do imóvel perfeito até a finalização da compra. Com a Pilar, você encontra segurança, confiança e a certeza de estar fazendo o melhor investimento. Descubra o seu próximo lar em São Paulo com a Pilar.'
	},
	questions: [
		{
			question: `Onde fica o ${regionName}?`,
			answer:
				'O Itaim Bibi está localizado na Zona Sul da cidade de São Paulo, dentro do distrito de mesmo nome e administrado pela Subprefeitura de Pinheiros. O bairro faz parte de um região nobre da cidade, fazendo fronteira com os bairros Jardim Europa, Jardim Paulista, Vila Nova Conceição e Pinheiros. Suas principais vias incluem a Avenida Brigadeiro Faria Lima e a Avenida Juscelino Kubitschek, que proporcionam uma excelente infraestrutura e mobilidade ao bairro.'
		},
		{
			question: `Como chegar ao ${regionName}?`,
			answer:
				'O Itaim Bibi é de fácil acesso de carro, com importantes avenidas que conectam o bairro a outras regiões da cidade. As principais vias de acesso incluem a Av. Faria Lima, Av. Juscelino Kubitschek e a Marginal Pinheiros, que garantem uma boa mobilidade tanto para quem vem da Zona Sul quanto de outras áreas de São Paulo. Para quem utiliza transporte público, há também várias linhas de ônibus e estações de metrô nas proximidades, facilitando a chegada de diferentes pontos da cidade.'
		},
		{
			question: `O que fazer no ${regionName}?`,
			answer:
				' O Itaim Bibi oferece diversas opções de lazer e entretenimento. Durante o dia, você pode visitar o Parque do Povo, que é o coração do bairro e oferece uma área verde ampla com trilhas para caminhadas, quadras esportivas e espaços para piqueniques. A poucos quilômetros de distância, o Parque Ibirapuera é ideal para quem busca um dia mais longo de diversão, com opções como aluguel de bicicletas, exposições culturais no Pavilhão Japonês e concertos no Auditório Oscar Niemeyer.<br/><br/>Para quem prefere clubes, o Esporte Clube Pinheiros, localizado na Av. Faria Lima, é conhecido por suas diversas modalidades esportivas e forma alguns dos principais atletas do país. Já a Sociedade Harmonia de Tênis, é um clube exclusivo que conta com quadras de saibro para a prática de tênis e um ambiente que prioriza privacidade e conforto. À noite, o Itaim Bibi se transforma em um centro boêmio, com bares e restaurantes renomados, que oferecem desde sushis sofisticados até petiscos em ambientes descontraídos.'
		},
		{
			question: `Onde comer no ${regionName}?`,
			answer:
				'O bairro é famoso por sua rica gastronomia. Entre os restaurantes destaques, estão o Nagayama e o Nakka, que oferecem sushis de alta qualidade, e restaurantes italianos renomados como o Nino Cucina e o Modern Mamma. Para uma experiência mais descontraída, o Boteco Rainha e a Trilha Cervejaria oferecem bons petiscos e bebidas.'
		}
	],
	hero: {
		title: regionName,
		description:
			'Sua conexão entre vida pessoal e profissional está em um dos bairros mais procurados e queridos de São Paulo.',
		backgroundImage: getUrlFromStaticDNS(
			'/images/regions/itaim-bibi/banner.webp'
		)
	},
	map: {
		title: 'Itaim Bibi: onde comer, se divertir e viver bem',
		content: `Localizado entre duas das principais avenidas de São Paulo e sendo cortado pela Faria Lima, polo de negócios mais importante da capital paulista, o Itaim Bibi é perfeito para quem quer aliar uma ótima localização com boas escolas, bons restaurantes e uma das melhores qualidades de vida da cidade.<br/><br/>
Se de dia o bairro vive uma energia de hub de inovação com suas diversas startups e big techs, à noite, o Itaim Bibi se transforma em um bairro boêmio com ótimas opções de bares e restaurantes, seja para curtir um happy hour do trabalho, uma noite a dois ou até sair com as crianças para jantar.<br/><br/>
Aos fins de semana, o Itaim Bibi é perfeito para quem procura opções de lazer praticamente sem sair de casa. Os badalados restaurantes abrem o dia inteiro, o que torna mais fácil a decisão de onde fazer o almoço especial. Já os parques são ótimas pedidas para quem quer aproveitar um dia ao ar livre. Para quem busca diversão para toda a família ou quer um lugar seguro para deixar os filhos, os clubes que ficam ao redor do bairro são ótimas escolhas. A seguir, apresentamos o que torna este bairro no coração da zona sul de São Paulo um dos mais especiais para se viver.`,
		image: '/images/regions/itaim-bibi/map.webp',
		links: [
			{
				label: 'Ver imóveis no Itaim Bibi',
				url: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [],
					regions: [regionName],
					states: ['SP'],
					cities: ['São Paulo']
				})
			}
		]
	},
	content: [
		{
			info: {
				title: 'Restaurantes no Itaim Bibi',
				content:
					'Não faltam opções no Itaim Bibi para quem ama comer bem, dos restaurantes estrelados aos botecos para fazer um happy hour. O badalado Nagayama, localizado na rua Bandeira Paulista, conta com um dos melhores sushis de São Paulo. Já o querido Nakka fica localizado na Pedroso Alvarenga. Para uma versão mais contemporânea da culinária japonesa, a pedida é o Watanabe.<br/><br/>Se você é fã de comida italiana, não pode perder os restaurantes localizados na rua Jerônimo da Veiga, conhecida no Itaim Bibi por seus ótimos restaurantes. Em duas quadras, você pode se deliciar com o Nino Cucina, Da Marino, Giulietta e Forno da Pino. Ali perto, o Modern Mamma serve uma gastronomia italiana contemporânea premiada. <br/><br/> Recém inaugurado em São Paulo, o Boteco Rainha é perfeito para quem quer aproveitar um ar descontraído com bons petiscos e chopp trincando. Ainda no Itaim Bibi, a Trilha Cervejaria conta com uma gama de cervejas artesanais e petiscos que levam a bebida como ingrediente.',
				class: 'row-span-2'
			},
			images: [
				{
					url: '/images/regions/itaim-bibi/content/content-1.webp',
					credits: 'Forno da Pino'
				},
				{ url: '/images/regions/itaim-bibi/content/content-2.webp' }
			]
		},
		{
			info: {
				title: 'Clubes no Itaim Bibi',
				content:
					'No Itaim Bibi, o que não falta é opção de lazer. Localizado entre Jardim Europa, Jardim Paulista, Vila Nova Conceição e Pinheiros, o bairro está rodeado por clubes exclusivos. Se você procura um lugar para praticar esportes, conhecer outros moradores, curtir os finais de semana na beira da piscina e ainda garantir um lugar seguro e divertido para as crianças, os clubes a menos de 2km do bairro serão perfeitos para você.<br/><br/>Um dos mais tradicionais de São Paulo, o Esporte Clube Pinheiros está localizado na Av. Faria Lima, ao lado do Shopping Iguatemi. É conhecido por sua vasta gama de esportes e forma alguns dos principais atletas do país. <br/><br/>Do outro lado da avenida, no Jardim América, a Sociedade Harmonia de Tênis é conhecida por ser uma das mais exclusivas da cidade. Com apenas 4 mil sócios, o clube é focado na prática do tênis e conta com nove quadras de saibro.<br/><br/>Pertinho do Esporte Clube Pinheiros, o Clube Hebraica reúne 22 mil sócios e conta com escola maternal e infantil, além de uma série de atividades voltadas para empreendedores, de co-working à cursos profissionalizantes.'
			},
			images: [
				{ url: '/images/regions/itaim-bibi/content/content-3.webp' },
				{ url: '/images/regions/itaim-bibi/content/content-4.webp' }
			]
		},
		{
			info: {
				title: 'Os parques ao redor do Itaim Bibi',
				content:
					'O Parque do Povo é o coração do Itaim Bibi. Localizado no cruzamento da Marginal Pinheiros e da Av. Cidade Jardim, o parque é cercado pelos principais escritórios de tecnologia de São Paulo, se tornando um ponto de descompressão pós expediente. Aos fins de semana, adultos e crianças lotam o gramado central do parque para aproveitar um tempo em família. O ponto também é um dos favoritos dos corredores, que aproveitam o circuito plano e bem asfaltado para fazerem seus treinos.<br/><br/>A poucos quilômetros do Itaim Bibi, o Parque Ibirapuera é perfeito para quem quer um programa que dura o dia todo. Do aluguel de bicicletas para dar uma volta em torno do lago, passando pelos festivais do Pavilhão Japonês aos concertos no Auditório Oscar Niemeyer, não faltarão opções para aproveitar o fim de semana. Uma boa dica é aproveitar alguns dos cafés distribuídos pelo parque para começar o dia cheio de energia.'
			},
			images: [
				{ url: '/images/regions/itaim-bibi/content/content-5.webp' },
				{ url: '/images/regions/itaim-bibi/content/content-6.webp' }
			]
		},
		{
			info: {
				title: 'Imóveis no Itaim Bibi',
				content:
					'Nem só de prédios comerciais se vive o Itaim Bibi. Lotado de história, o bairro paulista carrega consigo alguns dos edifícios mais icônicos de São Paulo, como o Edifício Gravatá, projetado pelo arquiteto brasileiro Rino Levi. Com uma arquitetura de assinatura própria, o prédio combina texturas, misturando concreto e tijolo em uma obra única e atemporal.<br/><br/>Se você quer muito luxo e sofisticação, o Itaim Bibi é um dos melhores bairros para investir. Pronto para morar, a rede de hotéis Fasano acaba de lançar seu empreendimento imobiliário de alto padrão no coração do bairro, o Fasano Itaim. Com 4 suítes e 228 m², o prédio conta com lazer completo e um toque que só o Fasano pode oferecer, como uma assessoria de eventos internos que ajuda os moradores a fazerem festas na unidade ou no salão localizado no condomínio.'
			},
			images: [
				{
					url: '/images/regions/itaim-bibi/content/content-7.webp',
					class: 'row-start-2',
					credits: 'Daniel Pinheiro'
				},
				{
					url: '/images/regions/itaim-bibi/content/content-8.webp',
					class: 'row-start-2'
				}
			]
		}
	],
	seo: {
		title: `Quem se interessou por ${regionName} também procurou por`,
		links: [
			{
				title: 'Tipo de imóvel',
				links: [
					{
						label: 'Apartamento',
						route: PropertyFiltersPresenter.getPathFromFilters({
							propertyTypes: [PropertyTypeEnum.APARTMENT],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Cobertura',
						route: PropertyFiltersPresenter.getPathFromFilters({
							propertyTypes: [PropertyTypeEnum.PENTHOUSE],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Duplex',
						route: PropertyFiltersPresenter.getPathFromFilters({
							propertyTypes: [PropertyTypeEnum.DUPLEX],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					}
				]
			},
			{
				title: '',
				links: [
					{
						label: 'Garden',
						route: PropertyFiltersPresenter.getPathFromFilters({
							propertyTypes: [PropertyTypeEnum.GARDEN],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},

					{
						label: 'Casa de vila',
						route: PropertyFiltersPresenter.getPathFromFilters({
							propertyTypes: [PropertyTypeEnum.VILLAGE_HOUSE],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					},
					{
						label: 'Loft',
						route: PropertyFiltersPresenter.getPathFromFilters({
							propertyTypes: [PropertyTypeEnum.LOFT],
							states: ['sp'],
							cities: ['São Paulo'],
							regions: [regionName]
						})
					}
				]
			},
			{
				title: 'Localização',
				links: [
					{
						label: 'Jardim Paulista, São Paulo',
						route: PropertyFiltersPresenter.getPathFromFilters({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Jardim Paulista']
						})
					},
					{
						label: 'Vila Nova Conceição, São Paulo',
						route: PropertyFiltersPresenter.getPathFromFilters({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Vila Nova Conceição']
						})
					},
					{
						label: 'Jardim América, São Paulo',
						route: PropertyFiltersPresenter.getPathFromFilters({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Jardim América']
						})
					}
				]
			},
			{
				title: '',
				links: [
					{
						label: 'Higienópolis, São Paulo',
						route: PropertyFiltersPresenter.getPathFromFilters({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Higienópolis']
						})
					},
					{
						label: 'Brooklin, São Paulo',
						route: PropertyFiltersPresenter.getPathFromFilters({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Brooklin']
						})
					},
					{
						label: 'Moema, São Paulo',
						route: PropertyFiltersPresenter.getPathFromFilters({
							states: ['sp'],
							cities: ['São Paulo'],
							regions: ['Moema']
						})
					}
				]
			}
		],
		discoveryContent: {
			heading: `Mais sobre o ${regionName}`,
			paragraphs: [
				'O Itaim Bibi é um dos bairros mais cobiçados de São Paulo, perfeito para quem deseja combinar uma localização privilegiada com alta qualidade de vida. Localizado entre algumas das principais avenidas da cidade, como a Faria Lima, o bairro oferece uma infraestrutura completa, com excelentes opções de lazer, restaurantes renomados e imóveis de alto padrão.',
				'O bairro abriga renomados restaurantes, como o Nagayama e o Nino Cucina, que oferecem desde sushis renomados até autêntica comida italiana. Para o lazer, o bairro é cercado por clubes como o Esporte Clube Pinheiros, a Sociedade Harmonia de Tênis, e Clube Hebraica, nas proximidades. O Parque do Povo é um ótimo espaço para relaxar, enquanto o Parque Ibirapuera, nas proximidades, proporciona um dia repleto de atividades ao ar livre. Os imóveis no Itaim Bibi incluem construções icônicas e opções luxuosas, como o Edifício Gravatá, projetado pelo  arquiteto Rino Levi, e o novo Fasano Itaim, que traz a elegância e excelência da rede Fasano. O Fasano Itaim é um exemplo claro do alto padrão que caracteriza o bairro, com ambientes que refletem a sofisticação e o estilo de vida dos moradores do bairro.'
			]
		}
	},
	nearRegions: [
		{
			image: '/images/regions/jardim-paulista/banner.webp',
			name: 'Jardim Paulista',
			href: '/bairros/jardim-paulista'
		},
		{
			image: '/images/regions/vila-nova-conceicao/banner.webp',
			name: 'Vila Nova Conceição',
			href: '/bairros/vila-nova-conceicao'
		},
		{
			image: '/images/regions/jardim-america/banner.webp',
			name: 'Jardim América',
			href: '/bairros/jardim-america'
		},
		{
			image: '/images/regions/pinheiros/banner.webp',
			name: 'Pinheiros',
			href: '/bairros/pinheiros'
		},
		{
			image: '/images/regions/alto-de-pinheiros/banner.webp',
			name: 'Alto de Pinheiros',
			href: '/bairros/alto-de-pinheiros'
		},
		{
			image: '/images/regions/jardim-europa/banner.webp',
			name: 'Jardim Europa',
			href: '/bairros/jardim-europa'
		},
		{
			image: '/images/regions/jardim-paulistano/banner.webp',
			name: 'Jardim Paulistano',
			href: '/bairros/jardim-paulistano'
		}
	]
};

export default region;
